export default "__VITE_ASSET__DiPXmPL1__"